var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHairFollicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#7ea3d8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M221.982,283.066c-6.309,10.672-10.869,23.479-10.869,37.743c0,33.534,22.459,60.725,50.163,60.725 c27.705,0,49.512-20.462,50.832-55.444c0.514-13.673-2.64-29.051-10.715-41.738c-9.72-15.318-21.944-21.045-26.247-41.437 c-19.802-93.728-65.774-225.951-93.496-231.231c9.54,14.307,43.846,152.891,51.252,237.831 C234.514,268.065,228.942,271.305,221.982,283.066z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M297.27,186.853c-8.161,0-4.492,17.796,6.549,38.395c3.36,6.283,6.24,9.104,13.149,16.93 c4.218,4.8,9.49,10.783,14.461,18.601c11.503,18.104,17.367,40.632,16.51,63.416c-2.006,53.044-37.392,90.11-86.063,90.11 c-47.044,0-85.326-43.572-85.326-97.104c0-19.656,5.452-38.84,16.201-57.039c1.928-3.248,3.729-5.966,5.177-8.16 c1.106-1.672,2.777-4.192,3-4.843c0.009-0.009,1.466-4.586,3.574-9.421c10.295-23.538,8.829-50.884-19.124-50.884H0v313.463h512 V186.853H297.27z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHairFollicle);
export default __webpack_public_path__ + "static/media/hair_follicle.c33e0fa382f19b2ab1e76896a4fd090a.svg";
export { ForwardRef as ReactComponent };